import React from 'react'
import banner from '../assets/imgs/banner.jpg'
const Banner = () => {
  return (
    <div>
      <img src={banner} alt="Loading..." className='w-full h-auto mt-16' />
    </div>
  )
}

export default Banner
